import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import dayjs, { isDayjs } from "dayjs";
import "dayjs/locale/it";
import {
	COMBO,
	DATEFIELD,
	SEARCHWINDOW,
	SWITCH,
	TEXTAREA,
	TEXTFIELD,
	GRID,
	BUTTON,
	CHECKBOX,
	NUMBERFIELD,
	DIVIDER,
	DYNAMICCOMBO,
	TAB,
	PARAGRAPH,
	LABEL,
	IMAGE_BOX,
	RADIOGROUP,
	SIMPLEGRID,
} from "../utils/ComponentList";
import SaitCombo from "../atomic/SaitCombo";
import SaitSwitch from "../atomic/SaitSwitch";
import SaitDateField from "../atomic/SaitDateField";
import SaitTextField from "../atomic/SaitTextField";
import SaitSearchTextField from "../atomic/SaitSearchTextField";
import FiltersAndGrid from "./FiltersAndGrid";
import SaitCheckbox from "../atomic/SaitCheckbox";
import SaitButton from "../atomic/SaitButton";
import SaitNumberField from "../atomic/SaitNumberField";
import { Divider, Tab, Tabs } from "@mui/material";
import SaitDynamicCombo from "../atomic/SaitDynamicCombo";
import { BUTTON_UPLOAD } from "../utils/ButtonTypes";
import SaitButtonUpload from "../atomic/SaitButtonUpload";
import { useSelector } from "react-redux";
import { ModuleContext } from "../utils/Constants";
import { isComponentVisible } from "../utils/SaitUtils";
import SaitRadioGroup from "../atomic/SaitRadioGroup";
import SimpleGrid from "./SimpleGrid";

export default function EditPanel(props) {
	const defaultWidth = 150;
	const defaultDateWidth = 140;
	const defaultColumnWidth = 500;
	const defaultSize = "small";

	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);

	const onChangeItem = (name, value, afterChange) => {
		props.setFunction((prevState) => {
			return {
				...prevState,
				[name]: value,
			};
		});

		if (afterChange) {
			afterChange(value);
		}
	};

	const onChangeComboItem = (selectedRow, name, afterChange) => {
		if (!selectedRow) {
			selectedRow = {};
		}

		let newStateElement = { ...props.stateElement };
		name.forEach((item) => {
			newStateElement[item.storeName] = selectedRow[item.comboName];
		});

		props.setFunction(newStateElement);
		if (afterChange) {
			afterChange(selectedRow);
		}
	};

	const onChangeSearchItem = (selectedRow, name, afterChange) => {
		if (!selectedRow) {
			selectedRow = {};
		}

		let newStateElement = { ...props.stateElement };
		name.forEach((item) => {
			newStateElement[item.storeName] = selectedRow[item.gridName];
		});

		props.setFunction(newStateElement);

		if (afterChange) {
			afterChange(selectedRow);
		}
	};

	const onChangeDateitem = (name, value, afterChange) => {
		let formattedValue = null;
		if (value) {
			formattedValue = dayjs(value);
		}
		props.setFunction((prevState) => ({
			...prevState,
			[name]: formattedValue,
		}));

		afterChange?.(formattedValue);
	};

	const onChangeDateitemNoDay = (name, value, last, afterChange) => {
		let formattedValue = null;
		if (value) {
			if (last) {
				//se passata props.lastDayOfMonth: inserisce l'ultimo giorno del mese
				const month = dayjs(value).get("month");
				formattedValue = dayjs(value)
					.set("date", 1)
					.set("month", month + 1)
					.subtract(1, "day");
			} else {
				//default: inserisce il primo del mese
				formattedValue = dayjs(value).set("date", 1);
			}
		}

		props.setFunction((prevState) => ({
			...prevState,
			[name]: formattedValue,
		}));

		afterChange?.(formattedValue);
	};

	const checkRequiredForError = (attemptSave, require, value) => {
		return attemptSave && require && (typeof value === "undefined" || value === null || value === "");
	};

	const checkRequiredForErrorDate = (attemptSave, require, value) => {
		return attemptSave && require && (typeof value === "undefined" || value === null || value === "" || (isDayjs(value) && isNaN(value.toDate().getTime())));
	};

	const componentChoice = (paragraph, item, index) => {
		switch (item.type) {
			case TEXTFIELD:
				return (
					<TextFieldEditPanel
						{...item}
						key={index}
						label={item.label}
						error={item.error ? item.error : checkRequiredForError(props.attemptSave, item.required, props.stateElement[item.name])}
						value={item.value || item.value === 0 ? item.value : props.stateElement[item.name] || ""}
						sx={{
							"& .MuiInputBase-input": {
								fontSize: item.fontSize ? item.fontSize : "default",
								fontWeight: item.fontWeight ? item.fontWeight : "default", // Imposta la dimensione del carattere del testo inserito
								padding: item.padding ? item.padding : "default",
							},
							flex: item.width || paragraph.flexDirection === "column" ? null : "1 0 " + defaultWidth + "px",
							width: item.width ? item.width : "100%",
						}}
						disabled={item.disabled || props.disabledAll}
						size={item.size || defaultSize}
						onChange={(newValue) => {
							onChangeItem(item.name, newValue, item.afterChange);
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								e.preventDefault();
								item?.onEnter?.();
							}
						}}
						required={item.required}
						autoFocus={item.autoFocus}
					/>
				);
			case TEXTAREA:
				return (
					<TextFieldEditPanel
						{...item}
						key={index}
						label={item.label}
						error={item.error ? item.error : checkRequiredForError(props.attemptSave, item.required, props.stateElement[item.name])}
						value={item.value || item.value === 0 ? item.value : props.stateElement[item.name] || ""}
						sx={{
							flex: item.width || paragraph.flexDirection === "column" ? null : "1 0 " + defaultWidth + "px",
							width: item.width ? item.width : "100%",
							background: item.backgroundColor,
						}}
						disabled={item.disabled || props.disabledAll}
						size={item.size || defaultSize}
						onChange={(newValue) => onChangeItem(item.name, newValue, item.afterChange)}
						multiline
						minRows={item.minRows}
						required={item.required}
					/>
				);
			case NUMBERFIELD:
				return (
					<NumberFieldEditPanel
						{...item}
						key={index}
						label={item.label}
						error={item.error ? item.error : checkRequiredForError(props.attemptSave, item.required, props.stateElement[item.name])}
						value={item.value || item.value === 0 ? item.value : props.stateElement[item.name]}
						sx={{
							flex: item.width || paragraph.flexDirection === "column" ? null : "1 0 " + defaultWidth + "px",
							width: item.width ? item.width : "100%",
							background: item.backgroundColor,
						}}
						disabled={item.disabled || props.disabledAll}
						size={item.size || defaultSize}
						onChange={(e) => onChangeItem(item.name, e, item.afterChange)}
						required={item.required}
					/>
				);
			case DATEFIELD:
				return (
					<SaitDateField
						{...item}
						key={index}
						label={item.label}
						error={item.error ? item.error : checkRequiredForErrorDate(props.attemptSave, item.required, props.stateElement[item.name])}
						value={props.stateElement[item.name]}
						sx={{
							flex: null,
							width: item.width ? item.width : defaultDateWidth,
						}}
						disabled={item.disabled || props.disabledAll}
						size={item.size || defaultSize}
						onChange={
							item.noDay
								? (newDate) => onChangeDateitemNoDay(item.name, newDate, item.lastDayOfMonth, item.afterChange)
								: (newDate) => onChangeDateitem(item.name, newDate, item.afterChange)
						}
						required={item.required}
						time={item.time || false}
					/>
				);
			case SEARCHWINDOW:
				return (
					<SaitSearchTextField
						{...item}
						key={index}
						label={item.label}
						value={props.stateElement}
						error={item.error ? item.error : checkRequiredForError(props.attemptSave, item.required, props.stateElement[item.name[0].storeName])}
						name={item.name}
						sx={{
							flex: item.width || paragraph.flexDirection === "column" ? null : "1 0 " + defaultWidth + "px",
							width: item.width ? item.width : "100%",
						}}
						onChange={(row) => onChangeSearchItem(row, item.name, item.afterChange)}
						onClear={item.onClear}
						searchWindow={item.searchWindow}
						disabled={item.disabled || props.disabledAll}
						size={item.size || defaultSize}
						description={item.description}
						required={item.required}
					/>
				);
			case COMBO:
				return (
					<SaitCombo
						{...item}
						key={index}
						label={item.label}
						value={props.stateElement}
						error={item.error ? item.error : checkRequiredForError(props.attemptSave, item.required, props.stateElement[item.name[0].storeName])}
						name={item.name}
						onChange={(row) => onChangeComboItem(row, item.name, item.afterChange)}
						sx={{
							flex: item.width || paragraph.flexDirection === "column" ? null : "1 0 " + defaultWidth + "px",
							width: item.width ? item.width : "100%",
						}}
						disabled={item.disabled}
						readOnly={item.readOnly || props.disabledAll}
						size={item.size}
						description={item.description}
						findParameters={item.findParameters}
						items={item.items}
						required={item.required}
					/>
				);
			case DYNAMICCOMBO:
				return (
					<SaitDynamicCombo
						{...item}
						key={index}
						index={index}
						stateElement={props.stateElement}
						setFunction={props.setFunction}
						sx={{
							flex: item.width || paragraph.flexDirection === "column" ? null : "1 0 " + defaultWidth + "px",
							width: item.width ? item.width : "100%",
						}}
						error={checkRequiredForError(props.attemptSave, item.required, props.stateElement[item.name[0].storeName])}
						disabledAll={props.disabledAll}
					/>
				);
			case SWITCH:
				return (
					<SaitSwitch
						{...item}
						key={index}
						value={props.stateElement[item.name]}
						startLabel={item.startLabel}
						endLabel={item.endLabel}
						disabled={item.disabled || props.disabledAll}
						onChange={(checked) => {
							onChangeItem(item.name, checked, item.afterChange);
						}}
					/>
				);
			case CHECKBOX:
				return (
					<SaitCheckbox
						{...item}
						key={index}
						label={item.label}
						value={item.value || props.stateElement[item.name]}
						disabled={item.disabled || props.disabledAll}
						onChange={(checked) => {
							onChangeItem(item.name, checked, item.afterChange);
						}}
					/>
				);
			case RADIOGROUP:
				return (
					<SaitRadioGroup
						{...item}
						key={index}
						label={item.label}
						value={item.value || props.stateElement[item.name]}
						disabled={item.disabled || props.disabledAll}
						onChange={(value) => {
							onChangeItem(item.name, value, item.afterChange);
						}}
					/>
				);
			case GRID:
				return (
					<Fragment key={index}>
						<FiltersAndGrid {...item} />
					</Fragment>
				);
			case SIMPLEGRID:
				return (
					<Fragment key={index}>
						<SimpleGrid {...item} />
					</Fragment>
				);
			case LABEL:
				return (
					<Box
						key={index}
						sx={{
							width: item.width ? item.width : "100%",
							fontWeight: item.fontWeight ? item.fontWeight : "bold",
						}}
						fontSize={item.fontSize || "100%"}
					>
						{item.value || item.value === 0 ? item.value : props.stateElement[item.name] || ""}
					</Box>
				);
			case DIVIDER:
				return paragraph.flexDirection === "column" ? <Divider key={index} flexItem /> : <Divider key={index} orientation="vertical" flexItem />;
			case BUTTON:
				return <SaitButton key={index} {...item} text={item.label} icon={item.icon} />;
			case BUTTON_UPLOAD:
				return (
					<SaitButtonUpload
						key={index}
						sx={{ ml: "5px" }}
						text={item.text}
						onUpload={item.onUpload}
						endIcon={item.icon}
						multiple={item.multiple}
						accept={item.accept}
						variant={item.variant || "text"}
						disabled={item.disabled || props.disabledAll}
					/>
				);
			case IMAGE_BOX:
				return (
					<Box
						key={index}
						mt={2}
						display="flex"
						justifyContent="center"
						alignItems="center"
						height={450}
						width={450}
						bgcolor="#f0f0f0" // Colore di sfondo del box
						borderRadius={8} // Bordo arrotondato del box
						boxShadow={3} // Ombra del box
						p={2} // Padding interno del box
					>
						{item.imageUrl && (
							<img
								src={item.imageUrl}
								alt={item.alt}
								style={{
									height: "100%", // Altezza dell'immagine al 100% del contenitore
									maxHeight: "100%", // Altezza massima dell'immagine al 100% del contenitore
									width: "auto", // Larghezza automatica per mantenere le proporzioni
									maxWidth: "100%", // Larghezza massima dell'immagine al 100% del contenitore
									display: "block",
								}}
							/>
						)}
					</Box>
				);
			default:
				return null;
		}
	};

	const returnParagraph = (paragraph, index) => {
		return (
			<Box
				key={index}
				sx={{
					alignItems: paragraph.flexDirection === "column" ? "center" : null,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Card
					key={index}
					sx={{
						m: props.margin !== undefined ? props.margin : 1,
						width: paragraph.flexDirection === "column" ? paragraph.width || defaultColumnWidth : paragraph.width || null,
						p: props.padding !== undefined ? props.padding : 0,
					}}
					elevation={props.elevation !== undefined ? props.elevation : 5}
				>
					<CardContent
						sx={{
							p: props.contentPadding !== undefined ? props.contentPadding : 1,
							pb: props.contentPaddingBottom !== undefined ? props.contentPaddingBottom : "10px !important",
						}}
					>
						<Typography variant="h6">{paragraph.title}</Typography>
						<Box
							component="form"
							onSubmit={(e) => e.preventDefault()}
							sx={{
								"& > :not(style)": { m: 1 },
								display: "flex",
								flexWrap: "wrap",
								gap: "10px",
								flexDirection: paragraph.flexDirection === "column" ? "column" : "row",
								mt: "5px",
								mr: paragraph.flexDirection === "column" ? "30px" : "0px",
							}}
							noValidate
							autoComplete="off"
							alignItems="center"
						>
							{paragraph.items.map((item, index) => !item.hidden && componentChoice(paragraph, item, index))}
						</Box>
					</CardContent>
				</Card>
			</Box>
		);
	};

	const [choosenTab, setChoosenTab] = React.useState(0);
	const handleChangeTab = (event, newValue) => {
		setChoosenTab(newValue);
	};

	// Filtra i TAB visibili una sola volta
	const visibleTabs = props.fields.filter(
		(element) =>
			element.type === TAB &&
			isComponentVisible(
				objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === element.objmod),
				element.hidden,
			),
	);

	return (
		<Box sx={{ display: "block" }}>
			{/* Titoli delle Tabs */}
			{visibleTabs.length > 0 && (
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<Tabs value={choosenTab} onChange={handleChangeTab}>
						{visibleTabs.map((element, index) => (
							<Tab key={index} label={element.title} />
						))}
					</Tabs>
				</Box>
			)}

			{/* Contenuto delle Tabs */}
			<Box>
				{visibleTabs.map((element, index) => (
					<Fragment key={index}>
						{index === choosenTab &&
							element.items.map((childElement, indexChildElement) =>
								isComponentVisible(
									objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === childElement.objmod),
									childElement.hidden,
								)
									? childElement.type === PARAGRAPH || !childElement.type
										? returnParagraph(childElement, indexChildElement)
										: componentChoice(element, childElement, indexChildElement)
									: null,
							)}
					</Fragment>
				))}

				{/* Altri elementi NON-TAB visibili */}
				{props.fields.map((element, index) =>
					element.type !== TAB &&
					isComponentVisible(
						objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === element.objmod),
						element.hidden,
					)
						? returnParagraph(element, index)
						: null,
				)}
			</Box>
		</Box>
	);
}

function TextFieldEditPanel(props) {
	const { value, onChange, onEnter, afterChange, ...textfieldProps } = props;

	const [internalValue, setInternalValue] = useState(value ?? "");
	const debounceTime = 200;
	const debounceTimer = useRef(null);

	const oldValue = useRef(null);

	const handleChangeValue = (e) => {
		const newValue = e.target.value;

		oldValue.current = internalValue;

		setInternalValue(newValue);

		// reset debounce
		if (debounceTimer.current) {
			clearTimeout(debounceTimer.current);
		}

		debounceTimer.current = setTimeout(() => {
			onChange?.(newValue);
		}, debounceTime);
	};

	// sincronizza quando props.value cambia da fuori
	useEffect(() => {
		if (value !== internalValue && value !== oldValue.current) {
			setInternalValue(value ?? "");
		}
	}, [value]);

	// pulizia del timer su smontaggio
	useEffect(() => {
		return () => {
			if (debounceTimer.current) {
				clearTimeout(debounceTimer.current);
			}
		};
	}, []);

	return (
		<SaitTextField
			{...textfieldProps}
			value={internalValue}
			onChange={handleChangeValue}
			type={textfieldProps.tipo}
			// InputLabelProps={internalValue ? { shrink: true } : {}}
			onKeyDown={(e) => {
				if (e.key === "Enter") {
					e.preventDefault();
					if (debounceTimer.current) clearTimeout(debounceTimer.current);
					onChange?.(internalValue);
					onEnter?.(internalValue);
				}
			}}
		/>
	);
}

function NumberFieldEditPanel(props) {
	const { value, onChange, ...textfieldProps } = props;

	const [internalValue, setInternalValue] = useState(value ?? "");
	const debounceTime = 200;
	const debounceTimer = useRef(null);

	const oldValue = useRef(null);

	const handleChangeValue = (e) => {
		const newValue = e.target.value;

		oldValue.current = internalValue;

		setInternalValue(newValue);

		// reset debounce
		if (debounceTimer.current) {
			clearTimeout(debounceTimer.current);
		}

		debounceTimer.current = setTimeout(() => {
			const parsedValue = newValue === "" ? "" : Number(newValue);
			onChange?.(parsedValue);
		}, debounceTime);
	};

	const handleBlur = (e) => {
		if (debounceTimer.current) clearTimeout(debounceTimer.current);

		const newValue = e.target.value;
		setInternalValue(newValue);
		const parsedValue = newValue === "" ? "" : Number(newValue);
		onChange?.(parsedValue);
	};

	// sincronizza quando props.value cambia da fuori
	useEffect(() => {
		if (value !== internalValue && value !== oldValue.current) {
			setInternalValue(value ?? "");
		}
	}, [value]);

	// pulizia del timer su smontaggio
	useEffect(() => {
		return () => {
			if (debounceTimer.current) {
				clearTimeout(debounceTimer.current);
			}
		};
	}, []);

	return (
		<SaitNumberField
			{...textfieldProps}
			value={internalValue}
			onChange={handleChangeValue}
			//  InputLabelProps={internalValue || value ? { shrink: true } : {}}
		/>
	);
}
